import axios, { AxiosError } from 'axios'
import config from 'config'
import AssetType from 'state/enums/AssetType'

import { OctaneLogger } from '../../integrations/datadog/OctaneLogger'

interface CollateralAssetResponse {
    id: number
    collateral: number
    condition: string
    year: number
    make: string
    model: string
}

interface MarineAsset extends CollateralAssetResponse {
    boat_type?: string
    length_ft?: number
    invoice_price?: number
    hours?: number
    horsepower?: number
    engine_type?: string
    fuel_type?: string
}

interface RVAsset extends CollateralAssetResponse {
    oem?: string
    rv?: number
    rv_type?: string
    manufacturer_price?: number
    wholesale_price?: number
    retail_price?: number
    mileage?: number
}

interface AutosAsset extends CollateralAssetResponse {
    oem?: string
    automobile_type?: string
    trim?: string
    color?: string
    invoice_price?: number
    booking_source?: string
    mileage?: number
    wholesale_price?: number
    like_invoice_price?: number
}

interface UccTitleDecision {
    id: number
    ucc_fee: number
    created: string
    updated: string
    document_type: string
    fee: string
}

export interface CollateralResponse {
    id: number
    asset: MarineAsset | RVAsset | AutosAsset
    ucc_title_decision: UccTitleDecision | null
    created: string
    updated_at: string | null
    asset_type: AssetType
    asset_name: string
    asset_value: string
    asset_valuation_method: string
    asset_sales_price: string | null
    unique_external_id: string | null
    data_source: string
}

export default async function getCollateralsAssets(
    applicationUuid: string,
    abortController: AbortController,
) {
    try {
        if (!applicationUuid) {
            throw new Error('invalid UUID')
        }

        const { data } = await axios.get(
            // eslint-disable-next-line max-len
            `${config.API_BASE_URL}/api/v3/applications/${applicationUuid}/collaterals-assets/`,
            {
                signal: abortController.signal,
                withCredentials: true,
            },
        )

        return data
    } catch (error) {
        const axiosError = error as AxiosError

        OctaneLogger.axiosError(
            `Failed to get collateral assets: ${axiosError.message}`,
            axiosError,
            { applicationUuid },
        )

        throw axiosError
    }
}
